<div class="modal-body">
  <p class="text-muted mb-2 mt-0">{{ 'PROPERTY.PROPERTY_DETAIL_DESCRIPTION' | translate }}</p>
  <div class="d-flex gap-2">
    <div class="flex-fill w-50">
      <p class="text-muted mb-0 ">{{ 'APARTMENT.METER_ID'| translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.id || '-' }}</p>
    </div>
    <div class="flex-fill w-50">
      <p class="text-muted mb-0 ">{{ 'APARTMENT.UNIT_TYPE'| translate }}</p>
      <p class="fw-medium fs-5" unitType [type]="meter?.unitType" [onlyText]="true"></p>
    </div>
  </div>
  <div class="d-flex gap-2">
    <div class="flex-fill w-50">
      <p class="text-muted mb-0 ">{{ 'METER.INSTALLATION_READING' | translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.installationReading || '-' }}</p>
    </div>
    <div class="flex-fill w-50">
      <p class="text-muted mb-0 ">{{ 'METER.STATUS' | translate }}</p>
      <label  [ngClass]="{
        'bg-primary text-light': meter?.connectivityStatus === 'Online' || meter?.connectivityStatus === 'online',
        'bg-danger bg-opacity-75 text-white': meter?.connectivityStatus === 'Offline' || meter?.connectivityStatus === 'offline'
      }" class="fw-medium fs-5 px-2 rounded-3">
        {{ meter?.connectivityStatus || '-' }}
      </label>
    </div>
  </div>
  <div class="d-flex">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'REPORTS.CATEGORY' | translate }}</p>
      <p class="fw-medium fs-5">
      {{ meter?.apartmentId ? ('METER.UNIT_TYPE' | translate) : ('METER.MAIN_METER' | translate) }} </p>
    </div>
  </div>
  <div class="d-flex gap-2 w-100">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'METER.LOCATION' | translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.installationLocation || '-' }}</p>
    </div>
  </div>
  <div class="d-flex">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'METER.MANUFACTURER'|translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.manufacturer || '-' }}</p>
    </div>
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'METER_TYPE.MODEL'|translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.model || '-' }}</p>
    </div>
  </div>
  <div class="d-flex">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'RESIDENTS.SERIAL_NUMBER'|translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.serialNumber || '-' }}</p>
    </div>
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'METER.INSTALLATIONDATE'|translate }}</p>
      <p class="fs-5 fw-medium">{{ !meter?.installationDate ? '-' : meter?.installationDate | date }}</p>
    </div>
  </div>
  <div class="d-flex gap-2 w-100">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'METER.LAST_UPDATED'|translate }}:</p>
      <p class="fs-5 fw-medium">{{ meter?.updatedAt | date }}</p>
    </div>
  </div>
  <div class="d-flex gap-2 w-100">
    <div class="w-50 flex-fill">
      <p class="text-muted mb-0 ">{{ 'APARTMENT.NOTES' | translate }}</p>
      <p class="fw-medium fs-5">{{ meter?.notes || '-' }}</p>
    </div>
  </div>
  <hr class="m-0 mb-2">
  <p class="mb-0 fw-medium">{{ 'PROPERTY.COUNTER_DEVELOPMENT'|translate }}</p>
  <apx-chart
    [chart]="areaChartOptionsByWeek.chart"
    [colors]="areaChartOptionsByWeek.colors"
    [dataLabels]="areaChartOptionsByWeek.dataLabels"
    [fill]="areaChartOptionsByWeek.fill"
    [grid]="areaChartOptionsByWeek.grid"
    [legend]="areaChartOptionsByWeek.legend"
    [plotOptions]="areaChartOptionsByWeek.plotOptions"
    [responsive]="areaChartOptionsByWeek.responsive"
    [series]="areaChartOptionsByWeek.series"
    [stroke]="areaChartOptionsByWeek.stroke"
    [tooltip]="areaChartOptionsByWeek.tooltip"
    [xaxis]="areaChartOptionsByWeek.xaxis"
    [yaxis]="areaChartOptionsByWeek.yaxis"
  />
</div>
